// Copyright 2019 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { IAuthentication } from "libraries/Authentication/IAuthentication";

@autoinject
export class UnauthorizedRedirect {
    constructor(
        private readonly authentication: IAuthentication,
        private readonly $window: Window
    ) {}

    public bind(): void {
        // Redirect to the sign in prompt
        this.authentication.signIn().catch(() => {
            // Unable to redirect to the sign in page, this can happen if we just went offline, take the user back to where he came from
            this.$window.history.back();
        });
    }
}
